<template>
    <header class="columns is-mobile" :class="{'no-border': noBorder}">
        <div class="column pl-0 pr-1 is-narrow">
            <i class="fad fa-fw mr-4 is-size-3" :class="icon"></i>
        </div>
        <div class="column pl-0">
            <h1 class="mt-0" v-if="title">{{ title }}<span class="count" v-if="count">{{ count }}</span></h1>
            <h2 class="mt-0" v-if="subtitle">{{ subtitle }}</h2>
        </div>

        <!-- Page-level close (leave a course, a conference, the bundle builder) -->
        <div class="column is-narrow menu has-text-right pr-0" v-if="close">
            <div class="pb-3">
                <router-link :to="closeRoute" class="close-link">
                    <b-tooltip :label="close" position="is-bottom">
                        <span class="close-label is-hidden-touch">{{ close }}</span>
                        <i class="fas fa-times"></i>
                    </b-tooltip>
                </router-link>
            </div>
        </div>
    </header>
</template>

<script>
    export default {
        name: "MainHeader",
        props: {
            'title': {},
            'subtitle': {},
            'icon': {},
            'close': {},
            'closeRoute': {},
            'count': {},
            'noBorder': {
                type: Boolean,
                default: false
            },
        }
    };
</script>

<style lang="scss" scoped>
    header {
        padding: 0;
        margin: 0.657rem 0 2.5rem;
        color: rgba(255, 255, 255, 1);
        border-bottom: 1px dashed rgba(255, 255, 255, 0.2);

        &.no-border {
            border-bottom: none;
        }

        h1 {
            font-weight: 400;
            font-size: 22px;
            margin-top: 1.1rem;
            display: inline-block;
            cursor: pointer;

            strong {
                color: rgb(255, 255, 255);
            }

            .count {
                display: inline-block;
                margin-left: 0.6rem;
                padding: 0 0.55rem;
                border-radius: 999px;
                background: rgba(255, 255, 255, 0.18);
                font-size: 0.8rem;
                font-weight: 600;
                line-height: 1.5rem;
                vertical-align: middle;
            }

            i {
                vertical-align: middle;
                color: rgb(255, 255, 255);
            }

            @media (max-width: 768px) {
                margin-top: 1rem;
                font-size: 18px;
            }
        }

        .menu {
            margin-top: 0;
            color: rgb(255, 255, 255);
            font-weight: bold;

            .close-link {
                display: inline-block;
                margin-top: 1.1rem;
                padding: 0.25rem 0.6rem;
                border: 1px solid rgba(255, 255, 255, 0.35);
                border-radius: 4px;
                color: white;
                font-size: 0.85rem;
                transition: background-color 150ms;

                &:hover {
                    background-color: rgba(255, 255, 255, 0.12);
                }

                .close-label {
                    margin-right: 0.6rem;
                }

                i {
                    cursor: pointer;
                    font-size: 1rem;
                    vertical-align: middle;
                }

                @media (max-width: 768px) {
                    margin-top: 1rem;
                }
            }
        }

        @media (max-width: 768px) {
            margin: 1.1rem 0 1rem;
        }
    }
</style>
